<template>
<loader v-bind="{ loading }">
  <div class="columns">
    <div class="column">
      <text-input 
        required
        :value="checkpoint.value"
        :error="$root.errorBag.value"
        @input="updateValue"
        placeholder="Password length must be at least 8 characters">
        Title
      </text-input>
    </div>
  </div>
  <div class="columns">
    <div class="column">
      <select-input 
        required
        :items="riskLevels"
        :error="$root.errorBag.risk_level"
        :value="checkpoint.risk_level"
        @input="updateRiskLevel">
        Risk Level
      </select-input>
    </div>
    <div class="column">
      <data-selector 
        required
        :items="cwes"
        label-key="number"
        value-key="id"
        :value="checkpoint.cwe_id"
        :error="$root.errorBag.cwe_id"
        @input="updateCwe">
        CWE
      </data-selector>
    </div>
  </div>

  <div class="columns">
    <div class="column">
      <text-area
        :value="checkpoint.corrective_measures"
        :error="$root.errorBag.corrective_measures"
        @input="updateCorrectiveMeasures">
        Corrective Measures
      </text-area>
    </div>
  </div>
  <submit-button 
    @submit="saveCheckpoint"
    :working="working"
    left-icon="save">
    Save
  </submit-button>    

</loader>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { getPath } from '@/api/common'

export default {

  data: () => ({
    working: false,
    loading: true,
    cwes: []
  }),

  beforeCreate() {
    Promise.all([
      getPath({ path: '/api/super/cwe-list' }, ({data}) => this.cwes = data, error => {}),
    ]).then(() => {
      this.loading = false
    })
  },

  methods: {
    ...mapMutations('checkpoint', [
      'updateValue',
      'updateCwe',
      'setAssessor',
      'updateRiskLevel',
      'updateCorrectiveMeasures'
    ]),
    saveCheckpoint() {
      this.working = true
      this.$store.dispatch('checkpoint/updateCheckpoint').then(() => {
        this.$toast.success('Saved')
        this.working = false
      }).catch(error => {
        this.working = false
      })
    },
    async deleteAssessor() {
      if(await this.$confirm({
        title: 'Delete Assesor',
        message: 'Are you sure you want to delete this assessor it will also delete all previous findings.'
      })) {
        this.$store.dispatch('assessor/deleteAssessor', this.assessor.id).then(() => {
          this.$store.commit('checkpoint/clearAssessor')
          this.$toast.success('Assessor Deleted')
        }).catch(error => {
          console.log(error)
        })
      }
    }
  },

  computed: {
    ...mapGetters('checkpoint', [
      'checkpoint',
      'riskLevels'
    ]),
    assessor() {
      return this.checkpoint.assessor
    }
  }

}
</script>
